export enum EnterPasswordEnum {
  ENTER,
  CORRECT,
  WRONG,
}
